export enum TableColumnType {
    TRANSLATE_NUMBER = 'translate-number',
    TRANSLATE_STATUS = 'translate-status',
    DATE = 'date',
    PRICE = 'price',
    MULTIUNIT = 'multiunit',
    STRING = 'string'
}
